import { z } from 'zod';

// ID-008 remediation: server-side length bounds
const EMAIL_MAX = 255;
const NAME_MAX = 100;
const PASSWORD_MIN = 8;
const PASSWORD_MAX = 128;

export const CreateUserInvitationRequestSchema = z
  .object({
    OrganizationId: z.string().uuid(),
    Email: z.string().min(1).max(EMAIL_MAX),
  })
  .strict();

export const CreateBulkUserInvitationRequestSchema = z
  .object({
    OrganizationId: z.string().uuid(),
    Emails: z.array(z.string().min(1).max(EMAIL_MAX)),
  })
  .strict();

export const ConfirmUpdateUserInvitationRequestSchema = z
  .object({
    Token: z.string().min(1),
    FirstName: z.string().min(1).max(NAME_MAX),
    LastName: z.string().min(1).max(NAME_MAX),
    Password: z.string().min(PASSWORD_MIN).max(PASSWORD_MAX),
  })
  .strict();
